import { DeckProps } from '@deck.gl/core';
import { MapboxOverlay } from '@deck.gl/mapbox';

import * as maptilersdk from '@maptiler/sdk';
import { VITE_MAPTILER_API_KEY } from '@utils/envs';
import { ReactNode } from 'react';
import { Map, MapRef, useControl, ViewState } from 'react-map-gl/maplibre';

interface MapComponentProps {
  mapRef?: React.RefObject<MapRef | null>;
  initialViewState?: Partial<ViewState>;
  layers?: DeckProps['layers'];
  children?: ReactNode;
  onMouseMove?: (event: any) => void;
}

function DeckGLOverlay(props: DeckProps) {
  const overlay = useControl<MapboxOverlay>(() => new MapboxOverlay(props));
  overlay.setProps(props);
  return null;
}

export const MapComponent = ({
  mapRef,
  initialViewState,
  layers,
  children,
  onMouseMove,
}: MapComponentProps) => {
  return (
    <div className="relative w-full h-full">
      <Map
        mapLib={maptilersdk}
        ref={mapRef}
        initialViewState={
          initialViewState || {
            longitude: -99.1332,
            latitude: 19.4326,
            zoom: 10,
          }
        }
        style={{ width: '100%', height: '100%' }}
        mapStyle={`https://api.maptiler.com/maps/019ac406-91cc-7778-9373-a8b3052f8a4e/style.json?key=${VITE_MAPTILER_API_KEY}`}
        onMouseMove={onMouseMove}
        dragRotate={false}
      >
        <DeckGLOverlay layers={layers || []} />
        {children}
      </Map>
    </div>
  );
};
